import { render } from "./ChangeSquadModal.vue?vue&type=template&id=05d90d7e"
import script from "./ChangeSquadModal.vue?vue&type=script&lang=js"
export * from "./ChangeSquadModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__